/* eslint-disable no-param-reassign */
import { trackAmpEvent } from "../../util/analytics/trackAmpEvent";

const prevTitles: Record<string, boolean> = {};
function sendEvent(eventName: string, title: string, properties: any) {
  if (!prevTitles[title]) {
    trackAmpEvent(eventName, title, properties);
    setTimeout(() => {
      prevTitles[title] = false;
    }, 3000);
  }
  prevTitles[title] = true;
}

export function ampLogEvent(title = "", properties = {}) {
  sendEvent("amplitude", title, properties);
}

export function klaviyoLogEvent(title = "", properties = {}) {
  sendEvent("klaviyo", title, properties);
}
